import {Component, OnInit} from '@angular/core';
import {FichetechniqueSupplier} from '../fichetechnique-produit/fichetechnique-resolver.service';
import {Subscription} from 'rxjs';
import {ProduitDTO} from '../../../core/dtos/produit-dto';
import {ActivatedRoute} from '@angular/router';
import {GenericDatagridService} from '../../../core/services/generics/generic-datagrid.service';
import {ProduitsService} from '../../../core/services/entities/produits.service';
import {HELP_FOLDERS, MSG_KEY, MSG_SEVERITY} from '../../../core/constants';
import {UtilsService} from '../../../core/utils/utils.service';
import {ProduitModeOperatoireDTO} from '../../../core/dtos/produit-mode-operatoire.dto';
import {DialogMsgSupplier} from '../../../core/suppliers/dialog-msg-supplier';
import {ToastService} from "../../../core/services/technique/toast.service";
import {ButtonThemeEnum} from '../../../shared/ui/button/button-theme-enum';


@Component({
    selector: 'yo-mode-operatoire-produit',
    templateUrl: './mode-operatoire-produit.component.html',
    styleUrls: ['./mode-operatoire-produit.component.scss'],
    standalone: false
})
export class ModeOperatoireProduitComponent implements OnInit {
  public readonly ButtonThemeEnum = ButtonThemeEnum;

  sub: Subscription;
  yoProduit: ProduitDTO;
  produitsModesOperatoires: ProduitModeOperatoireDTO[] = [];
  activeTabIndex: number = 0;

  pathFile: string = HELP_FOLDERS.PRODUITS + '/produits-mode-operatoire';

  displayDuplicationDialog: boolean = false;
  selectedModesOperatoiresToDuplicateId: number;
  modesOperatoiresDialogList: ProduitModeOperatoireDTO[] = [];
  selectedModesOperatoiresDialogList: ProduitModeOperatoireDTO[] = [];

  constructor(private route: ActivatedRoute,
              public gds: GenericDatagridService,
              public produitsService: ProduitsService,
              public utils: UtilsService,
              private toastSvc: ToastService) {
  }

  ngOnInit() {
    this.sub = this.route.data.subscribe((data: { fichetechniqueSupplier: FichetechniqueSupplier }) => {
      this.yoProduit = data.fichetechniqueSupplier.produitDTO;
      this.produitsModesOperatoires = data.fichetechniqueSupplier.produitsModesOperatoires;
      this.produitsModesOperatoires = this.produitsService.sortListeProduitModeOperatoireDTO(this.produitsModesOperatoires);
    });

  }

  checkValiditeModesOperatoires = (produitsModeOperatoireDTO: ProduitModeOperatoireDTO[]): boolean => {
    let valid: boolean = true;
    for (let produitModeOperatoireDTO of produitsModeOperatoireDTO) {
      if (!produitModeOperatoireDTO.modeOperatoire)
        continue;
      produitModeOperatoireDTO.modeOperatoire = produitModeOperatoireDTO.modeOperatoire.replace(/<br>/g, '<br/>');
      if (produitModeOperatoireDTO.modeOperatoire.match("<img ")) {
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `Le mode opératoire ne doit pas contenir d'images`);
        valid = false;
        break;
      }
    }
    return valid;
  };

  saveModeOperatoire = () => {
    const modeOperatoire = this.produitsModesOperatoires[this.activeTabIndex];
    if (modeOperatoire)
      this.saveModesOperatoires([modeOperatoire], `Le mode opératoire de la déclinaison ${modeOperatoire.libelleDeclinaison} a été enregistré avec succès`);
  };

  private saveModesOperatoires = (modeOperatoireList: ProduitModeOperatoireDTO[], successMessage: string) => {
    if (!this.checkValiditeModesOperatoires(modeOperatoireList))
      return;
    this.produitsService.saveModeOperatoire(this.yoProduit.id, modeOperatoireList).subscribe(response => {
        if (this.utils.isResponseSupplierError(response))
          return;
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, successMessage);
        this.produitsModesOperatoires = this.produitsModesOperatoires.map(modop =>
          response.resultList.find(saved => saved.idProduitDecline === modop.idProduitDecline) ?? modop);
      },
      error => this.utils.handleError(error, true));
  };

  trackByIdProduitDecline = (_: number, modop: ProduitModeOperatoireDTO): number => modop.idProduitDecline;

  canModify = (): boolean => {
    let response = this.gds.canModify(this.yoProduit);
    return response;
  };

  help = (): DialogMsgSupplier => undefined;


  closeDuplicationDialog() {
    this.displayDuplicationDialog = false;
    this.selectedModesOperatoiresToDuplicateId = undefined;
    this.modesOperatoiresDialogList = [];
    this.selectedModesOperatoiresDialogList = [];
  }

  onModeOperatoireDuplicateSelected(idProduitDecline: number) {
    this.selectedModesOperatoiresToDuplicateId = idProduitDecline;
    this.modesOperatoiresDialogList = this.produitsModesOperatoires.filter(modop => modop.idProduitDecline !== idProduitDecline);
  }

  onModeOperatoireSelectionChange(data: any) {
    this.selectedModesOperatoiresDialogList = data;
  }

  openDuclicationPopup() {
    this.displayDuplicationDialog = true;
  }

  isSaveDialogEnabled = () => {
    return this.selectedModesOperatoiresToDuplicateId && this.selectedModesOperatoiresDialogList.length > 0;
  };

  duplicateModeOperatoire() {
    const selectedModop = this.produitsModesOperatoires.find(modop => modop.idProduitDecline === this.selectedModesOperatoiresToDuplicateId);
    if (!selectedModop)
      return;
    const duplicatedList = this.selectedModesOperatoiresDialogList.map(modop => ({...modop, modeOperatoire: selectedModop.modeOperatoire}));
    this.closeDuplicationDialog();
    this.saveModesOperatoires(duplicatedList, `Le mode opératoire a été dupliqué avec succès`);
  }
}
